export const SHORT_LANGS_RU = {
  en: 'Англ',
  ru: 'Ру',
};
